import useEvolutionDashboard from 'features/useEvolutionDashboard';
import styles from './GradeTooltip.module.scss';

function GradeTooltip({active, payload}: any) {
  const {getDifferenceColor, getDifferenceText} = useEvolutionDashboard();

  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const {name, endDate, grade, gradeDifference} = payload[0]?.payload;

  const differenceColor = getDifferenceColor(gradeDifference);
  const differenceText = getDifferenceText(gradeDifference);

  return (
    <article
      role="tooltip"
      aria-live="polite"
      aria-atomic="true"
      aria-label={`Informações da nota para ${name}`}
      className={styles.container}
    >
      <header>
        <h2 style={{fontSize: '1rem'}}>{name}</h2>

        <time dateTime={new Date(endDate).toISOString()}>
          {new Date(endDate).toLocaleDateString('pt-BR')}
        </time>
      </header>

      <dl>
        <dt className={styles.gradeLabel}>
          Nota: <dd>{grade}</dd>
        </dt>

        {differenceText && (
          <span style={{color: differenceColor}} aria-live="polite">
            {differenceText}
          </span>
        )}
      </dl>
    </article>
  );
}

export default GradeTooltip;
